module.exports = __webpack_public_path__ + "img/强光峰.8f2fa90f.png";